"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _jsonpath = _interopRequireDefault(require("jsonpath"));
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _BuyAddonModal = _interopRequireDefault(require("./BuyAddonModal"));
var _formatSectionType = _interopRequireDefault(require("../utils/formatSectionType"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
//TODO to be removed after fixing extra padding in toggle component
var ToggleWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  > div {\n    padding: 0;\n  }\n"])));
var Summary = function Summary(_ref) {
  var _summarySection$find;
  var bundleDetails = _ref.bundleDetails,
    autoRenew = _ref.autoRenew,
    bundleName = _ref.bundleName,
    bundleId = _ref.bundleId;
  var t = (0, _useTranslation.default)();
  var _useConfig = (0, _useConfig2.default)(),
    summarySection = _useConfig.summarySection,
    _useConfig$buyButtonT = _useConfig.buyButtonTransKey,
    buyButtonTransKey = _useConfig$buyButtonT === void 0 ? 'buyAddon' : _useConfig$buyButtonT;
  var breakPoint = (0, _r10SourceLibrary.useBreakpoints)();
  var history = (0, _reactRouterDom.useHistory)();
  var _useState = (0, _react.useState)(autoRenew),
    _useState2 = _slicedToArray(_useState, 2),
    autoRenewToggle = _useState2[0],
    setAutoRenewToggle = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isBuyAddonModalOpen = _useState4[0],
    setIsBuyAddonModalOpen = _useState4[1];
  var hasAutoRenewToggle = summarySection.some(function (s) {
    return s.type === 'toggle';
  });
  var typeSectionJsonPath = (_summarySection$find = summarySection.find(function (s) {
    return s.type === 'type';
  })) === null || _summarySection$find === void 0 ? void 0 : _summarySection$find.jsonPath;
  var types = _jsonpath.default.query(bundleDetails, typeSectionJsonPath);
  var showTypesSection = typeSectionJsonPath && !!types.length;
  var showAutoRenew = typeSectionJsonPath && types.length > 1;
  (0, _react.useEffect)(function () {
    if (hasAutoRenewToggle && showAutoRenew) {
      var params = new URLSearchParams(_defineProperty({}, 'auto-renew', autoRenewToggle));
      history.replace({
        search: params.toString()
      });
    }
  }, [autoRenewToggle]);
  var getSummaryData = function getSummaryData(section, bundleData) {
    return section.filter(function (s) {
      return !(s.type === 'toggle' && !showAutoRenew);
    }).map(function (item, i, arr) {
      var value = item.jsonPath ? _jsonpath.default.query(bundleData, item.jsonPath) : [];
      if (item.fallbackPath && !value.length) {
        value = _jsonpath.default.query(bundleData, item.fallbackPath);
      }
      var isLastItem = arr.length - 1 === i;
      value = (0, _formatSectionType.default)(value, item.type, t);
      if (item.type === 'type' && !showTypesSection) return;
      return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
        spacing: 4,
        columns: {
          sm: 1
        },
        key: item.key
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
        key: item.key,
        noGutters: true,
        justify: "center",
        align: "center"
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
        col: "auto"
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
        noGutters: true,
        justify: "start",
        align: "center"
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          right: 2
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
        dataAttributes: {
          'data-testid': "".concat(item.key, "-icon")
        },
        name: item.icon,
        group: "system",
        size: 5
      })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-testid': "".concat(item.key, "-key")
        },
        noMargin: true,
        size: 2
      }, t(item.key), ":"))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
        noGutters: true,
        justify: "end",
        align: "left"
      }, item.type !== 'toggle' ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-testid': "".concat(item.key, "-value")
        },
        justify: "right",
        noMargin: true,
        size: 2
      }, value) : /*#__PURE__*/_react.default.createElement(ToggleWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Toggle, {
        id: "toggle",
        name: "toggle",
        value: autoRenewToggle,
        isActive: autoRenewToggle,
        showIcons: false,
        onChange: function onChange() {
          return setAutoRenewToggle(!autoRenewToggle);
        },
        dataAttributes: {
          'data-testid': 'autorenew-toggle'
        }
      }))))), !isLastItem && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
        level: 1,
        appearance: "primary",
        noMargin: true
      }));
    });
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: breakPoint.sm ? 4 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    spacing: 4,
    columns: {
      sm: 1
    }
  }, getSummaryData(summarySection, bundleDetails))), showTypesSection && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    width: "full",
    text: t("".concat(buyButtonTransKey)),
    onClick: function onClick() {
      return setIsBuyAddonModalOpen(true);
    },
    dataAttributes: {
      'data-testid': 'buy-button'
    }
  })), /*#__PURE__*/_react.default.createElement(_BuyAddonModal.default, {
    isModalOpen: isBuyAddonModalOpen,
    setIsModalOpen: setIsBuyAddonModalOpen,
    bundleDetails: bundleDetails,
    bundleName: bundleName,
    bundleId: bundleId,
    autoRenew: hasAutoRenewToggle && autoRenewToggle
  })));
};
Summary.propTypes = {
  bundleDetails: _propTypes.default.object,
  autoRenew: _propTypes.default.bool,
  bundleName: _propTypes.default.string,
  bundleId: _propTypes.default.string
};
var _default = Summary;
exports.default = _default;